/**
 * @description
 * ## 控制台输出
 * @module buttercam/console
 * */

/**
 * 带格式的控制台输出
 * @example
 * import Debug from "buttercam/console"
 *
 * const debug = Debug('Debug Test');
 *
 * debug.log('this is a test'); // => [ Debug Test ] this is a test
 * debug.error('this is a test') // same
 * ...
 * */
class Console {
  
  /**
   * 创建一个console
   * @param {string} scope - 前缀
   * */
  constructor(scope) {
    
    /**
     * 标签
     * @type {string}
     * */
    this.scope = scope;
  
    /**
     * 计时器
     * @type {object.<string, number>}
     * */
    this.timers = {};
  
    /**
     * 不同输出类型下的颜色值
     * @type {object.<string, string>}
     * */
    this.colorMap = {
      log: '#207806',
      warn: '#be981e',
      error: '#f01a1a',
      info: '#1041db',
      time: '#9397a6'
    };
  
    /**
     * 样式
     * @type {object.<string, function>}
     * */
    this.styles = {
      scope: (type) => {
        return `font-weight: bold;color: ${this.colorMap[type]}`
      }
    };
    
  }
  
  /**
   * 输出
   * @private
   * @param {string} type - 输出类型, [log, warn, error, info] 之一
   * @param {*} [message=""] - 输出消息
   * @param {string} [extra=""] - scope 附加标签
   * @param {string} [style] - scope 样式
   * @returns {Console}
   * */
  _output(type, message = '', extra = '', style) {
    let {scope, styles} = this;
    try {
      // eslint-disable-next-line no-console
      console[type](`%c[ ${scope+extra} ] `, style || styles.scope(type), message)
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log(`%c[ ${scope+extra} ] `, style || styles.scope('log'), message)
    }
    return this
  }
  
  /**
   * log类型
   * @param {*} message - 输出信息
   * @returns {Console}
   * */
  log(message) {
    return this._output('log', message)
  }
  
  /**
   * warn类型
   * @param {*} message - 输出信息
   * @returns {Console}
   * */
  warn(message) {
    return this._output('warn', message)
  }
  
  /**
   * error类型
   * @param {*} message - 输出信息
   * @returns {Console}
   * */
  error(message) {
    return this._output('error', message)
  }
  
  /**
   * info类型
   * @param {*} message - 输出信息
   * @returns {Console}
   * */
  info(message) {
    return this._output('info', message)
  }
  
  /**
   * 清空输出
   * @returns {Console}
   * */
  clear() {
    return this._output('clear')
  }
  
  /**
   * 开始计时
   * @param {string} scope - 计时标签
   * @returns {Console}
   * */
  time(scope) {
    if(!this.timers[scope]) {
      this.timers[scope] = (new Date()).getTime()
    } else {
      this.timers[scope] = (new Date()).getTime()
    }
    return this
  }
  
  /**
   * 停止计时
   * @param {string} scope - 计时标签
   * @returns {Console}
   * */
  timeEnd(scope) {
    let timer = this.timers[scope];
    let extra = ` - time - ${scope}`;
    if(!timer) {
      return this._output('warn', `${scope} is not defined`, extra)
    }
    return this._output('log', timer - (new Date()).getTime() + 'ms', extra, this.styles.scope('time'))
  }
  
}

export default Console

